import React from "react";
import styles from "./licenses.module.css";
import svidetelstvo from "../../files/images/svidetelstvo.png";
import svidpo from "../../files/images/svidpo.png";
import ImageComponent from "../../util/image.js";

class Licenses extends React.Component {
    constructor(props) {
        super(props);
        this.onShowSvidpo = this.onShowSvidpo.bind(this);
        this.onShowSvidetelstvo = this.onShowSvidetelstvo.bind(this);
    }

    onShowSvidetelstvo = () => {
        this.props.showModal(svidetelstvo);
    }
    onShowSvidpo = () => {
        this.props.showModal(svidpo);
    }

    render() {
      return (
          <React.Fragment>
              <div className={styles.container} style={{ textAlign: "center" }}>
                  <span>
                    <img src={svidetelstvo} style={{ width: "32%", height: "auto", cursor: "zoom-in"}} onClick={this.onShowSvidetelstvo}/>
                    </span>
                  <span className={styles.container} style={{ textAlign: "center" }}>
                      <img src={svidpo} style={{ width: "32%", height: "auto", cursor: "zoom-in" }} onClick={this.onShowSvidpo}/>
                  </span>
              </div>
          </React.Fragment>
    );
  }
}

export default Licenses;
